import { render, staticRenderFns } from "./UserAssignments.vue?vue&type=template&id=5d0fcba0&"
import script from "./UserAssignments.vue?vue&type=script&lang=js&"
export * from "./UserAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports